import { AuthState, authActionTypes, AuthActions } from 'Types/AuthTypes';
import * as immutable from 'immutable';

export interface AuthReducer {
  authReducer: AuthState;
}

export const defaultAuthState: AuthState = {
  isAuthenticated: false,
  tempSignUpPass: undefined,
  pendingEmailOrPhone: undefined,
  isLoading: false,
  oauthPending: false,
};

export const authReducer = (state = defaultAuthState, action: AuthActions): AuthState => {
  // console.log("authReducer received action", action);
  switch (action.type) {
    case authActionTypes.CLEAR_DATA:
      return { ...defaultAuthState };
    case authActionTypes.SET_TEMP_SIGNUP_PASS:
      return immutable.merge(state, {
        tempSignUpPass: action.payload,
      });
    case authActionTypes.SET_IS_AUTHENTICATED:
      return immutable.merge(state, {
        isAuthenticated: action.payload,
      });
    case authActionTypes.SET_PENDING_EMAIL_OR_PHONE:
      return immutable.merge(state, {
        pendingEmailOrPhone: action.payload,
      });
    case authActionTypes.SET_IS_LOADING:
      return immutable.merge(state, {
        isLoading: action.payload,
      });

    case authActionTypes.SET_OAUTH_PENDING:
      return immutable.merge(state, {
        oauthPending: action.payload,
      });
    default:
      return state;
  }
};
